<template>
	<!-- 	<div class="box">
	  <carousel-3d>
	    <slide v-for="(slide, i) in slides" :index="i" :key="i">
	      <h1>{{ slide.title }}</h1>
	      <p>{{ slide.desc }}</p>
	    </slide>
	  </carousel-3d>
	</div> -->
	<div class="box">
		<carousel-3d>
			<slide v-for="(item, i) in bitems" :index="i" :key="i">
				<template slot-scope="obj">
					<img :src="item.target" />
				</template>
			</slide>
		</carousel-3d>
	</div>
</template>

<script>
	import {
		Carousel3d,
		Slide
	} from 'vue-carousel-3d'
	export default {

		components: {
			Carousel3d,
			Slide
		},
		data() {
			return {
				bitems: [{
		
						name: '',
						url: 'javascript:;',
						target: 'http://hifooapp.oss-cn-shenzhen.aliyuncs.com/gdacs/684d98ae13d21ac3abbd39f5d87a5d6c.jpg?Expires=1750144871&OSSAccessKeyId=LTAI4GDPg1Rc6dbwjDsVA92D&Signature=kHcyDbXhV%2BTEXrL7BswypsrLRYw%3D',
						descrition: ''
					},
					{
						name: '',
						url: 'javascript:;',
						target: 'http://hifooapp.oss-cn-shenzhen.aliyuncs.com/gdacs/2bda2201c59260e3702439f5d87ab0e8.jpg?Expires=1750144891&OSSAccessKeyId=LTAI4GDPg1Rc6dbwjDsVA92D&Signature=9KKIXGq4a4wxDpwDqJaX4vB%2FBOw%3D',
						descrition: ''
					},
					{
						name: '',
						url: 'javascript:;',
						target: 'http://hifooapp.oss-cn-shenzhen.aliyuncs.com/gdacs/e46e0f5bd2457f848dc439f5d87b0408.jpg?Expires=1750144913&OSSAccessKeyId=LTAI4GDPg1Rc6dbwjDsVA92D&Signature=if8Ow1AQ0IzF%2FYRjlDrJ44swvRI%3D',
						descrition: ''
					}
				]
			}
		},

	}
</script>

<style scoped="scoped">
	img{
		height:100%;
	}
	.carousel-3d-container{
		margin:0px;
	}
	.VueCarousel-pagination{
		display: none;
	}
	.box{
		background-color: white;
	}
</style>
